// setTimeout stores its delay in a signed 32-bit int; anything larger overflows
// and fires immediately, so long waits are served by re-arming at this ceiling
// (~24.8 days) until the remaining time fits.
export const MAX_TIMEOUT = 2 ** 31 - 1;
